import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  TramiteSicProteccionConsumidorDto
} from '../../../../../dto/tramites/tramite-sic-proteccion-consumidor.dto';
import { ListaValorService } from '../services/lista-valor.service';
import {
  ListaValorRequestDto,
  ListaValorResponseDto,
} from '../../../../../dto/tramites/lista_valor.dto';
import { Constants } from '../../../../../constants/constants';
import { TranslateService } from '@ngx-translate/core';
import { TableColumn } from "../../../../../dto/util/table-column";
import { TipoPretensionDto } from "../../../../../dto/tramites/sic/tipo-pretension.dto";
import { ProteccionConsumidorService } from "../services/proteccion-consumidor.service";
import { AlertaModalService } from '../../../../../services/util/alerta-modal.service';

@Component({
  selector: 'app-pretensiones',
  templateUrl: './pretensiones.component.html',
  styleUrl: './pretensiones.component.scss',
})
export class PretensionesComponent implements OnInit, OnChanges {
  @Input() tramiteSic?: TramiteSicProteccionConsumidorDto;
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();
  @Output() pretension = new EventEmitter<{
    listaPretenciones: TipoPretensionDto[];
  }>();
  formPretension!: FormGroup;

  listaTipoPretension_pr_eg: ListaValorResponseDto[] = [];
  listaTipoPretension_pr_pc: ListaValorResponseDto[] = [];
  listaTipoPretension_pr_pvdc: ListaValorResponseDto[] = [];
  listaTipoPretension_pr_psib: ListaValorResponseDto[] = [];
  listaTipoPretension_pr_pie: ListaValorResponseDto[] = [];

  listaPretensionesPrincipales: TipoPretensionDto[] = [];

  columnsPretensiones: TableColumn[] = [];

  //Boolean
  mostar = false;
  principal = false

  // Multilenguaje
  proconText: any = {};
  comunText: any = {};
  alertaText: any = {};

  modificoPretension: boolean = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly listaValorService: ListaValorService,
    private readonly translate: TranslateService,
    private readonly proteccionConsumidorService: ProteccionConsumidorService,
    private readonly alertaModalService: AlertaModalService
  ) {
  }

  ngOnInit() {

    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
      for (const key of Object.keys(text)) {
        this.proconText[key] = text[key];
      }
      this.formPretension = this.fb.group({
        tipoPretension: ['', Validators.required],
        otraPretension: ['', [Validators.minLength(3), Validators.maxLength(1000)]],
        juramento: ['', [Validators.minLength(3)]],
        TP_requerida: new FormControl(false, Validators.requiredTrue)
      });
    });
    this.formPretension.get('tipoPretension')?.valueChanges.subscribe(value => {
      this.actualizarValidaciones(value);
    });

    this.listaValor();
    this.iniciarColumnas();
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSicProteccionConsumidorDto =
      changes['tramiteSic'].currentValue;

    //Si el tramite cambia, se setea toda la informacion del mismo
    if (tramite !== undefined) {
      if (tramite.tipoPretension !== undefined) {
        this.listaPretensionesPrincipales = [];
        this.cargarFormularioDesdeJSON(this.tramiteSic?.tipoPretension);
      }
      if (tramite.juramento !== undefined) {
        this.formPretension.get('juramento')?.setValue(tramite.juramento)
      }
    }
  }

  private iniciarColumnas() {
    this.columnsPretensiones = [
      {
        field: 'tipoPretension.valor',
        title: this.proconText['tramite-sic-procon']['pretension-seleccionada'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'otraPretension',
        title: this.proconText['tramite-sic-procon']['informacion-adicional'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];
  }

  listaValor() {
    this.listaValorService.lista('SIC_TIPO_PRETENSION_PR_EG').subscribe(data => {
      this.listaTipoPretension_pr_eg = data as ListaValorResponseDto[];
    });

    this.listaValorService.lista('SIC_TIPO_PRETENSION_PR_PC').subscribe(data => {
      this.listaTipoPretension_pr_pc = (data as ListaValorResponseDto[]).sort(
        (a, b) => a.Otro_valor!.localeCompare(b.Otro_valor!)
      );
    });

    this.listaValorService.lista('SIC_TIPO_PRETENSION_PR_PVDC').subscribe(data => {
      this.listaTipoPretension_pr_pvdc = (data as ListaValorResponseDto[]).sort(
        (a, b) => a.Otro_valor!.localeCompare(b.Otro_valor!)
      );
    });

    this.listaValorService.lista('SIC_TIPO_PRETENSION_PR_PSIB').subscribe(data => {
      this.listaTipoPretension_pr_psib = (data as ListaValorResponseDto[]).sort(
        (a, b) => a.Otro_valor!.localeCompare(b.Otro_valor!)
      );
    });

    this.listaValorService.lista('SIC_TIPO_PRETENSION_PR_PIE').subscribe(data => {
      this.listaTipoPretension_pr_pie = (data as ListaValorResponseDto[]).sort(
        (a, b) => a.Otro_valor!.localeCompare(b.Otro_valor!)
      );
    });
  }

  cargarFormularioDesdeJSON(data: TipoPretensionDto[] | undefined) {
    data?.forEach(item => {
      const codigo = item.tipoPretension?.codigo;
      const valor = item.tipoPretension?.valor;
      const id = item.tipoPretension?.id;
      const otraPretension = item.otraPretension || '';
      const principal = item.principal || false;
      const idDetalleSIC = item.id;

      this.listaPretensionesPrincipales.push({
        tipoPretension: { codigo, valor, id },
        otraPretension,
        principal,
        idDetalleSIC: idDetalleSIC
      });

      this.listaPretensionesPrincipales = this.limpiarPretensiones(this.listaPretensionesPrincipales);

      // Checkbox obligatorio
      if (codigo === 'TP_IPSE' || codigo === 'TP_DVNPP' || codigo === 'TP_DAASC' || codigo === 'TP_DRHD') {
        this.formPretension.get('TP_requerida')?.setValue(true);
      }

      const controlName = `detalle_${codigo}`;

      // Determinar si requiere validación
      const requiereValidacion = ['TP_AD', 'TP_MCO', 'TP_PI', 'TP_DAASC', 'TP_PSI', 'TP_AA'].includes(codigo!);
      const validators = requiereValidacion ? [Validators.required] : [];

      const control = new FormControl(otraPretension, validators);

      this.formPretension.addControl(controlName, control);
    });
  }


  agregar(principal: boolean) {
    this.mostar = true;
    this.principal = principal
  }

  habilitarBotonAgregar() {
    const tipoPretensionAux = this.formPretension.get('tipoPretension')?.value;
    const otraPretensionAux = this.formPretension.get('otraPretension')?.value;

    const tipoPretension = typeof tipoPretensionAux === 'string' ? tipoPretensionAux.trim() : '';
    const otraPretension = typeof otraPretensionAux === 'string' ? otraPretensionAux.trim() : '';

    if (!tipoPretension) return false;
    const tiposQueRequierenDetalle = ['TP_QRB', 'TP_COPL'];

    // Si requiere detalle, pero no se ha ingresado, NO guardar
    if (tiposQueRequierenDetalle.includes(tipoPretension) && !otraPretension) {
      return false;
    }

    // Si no requiere detalle, o el detalle está presente, SÍ guardar
    return true;
  }

  datosTablaPretensiones(principal: boolean): TipoPretensionDto[] {
    if (principal) {
      return this.listaPretensionesPrincipales.filter(
        item => item.principal === true
      );
    } else {
      return this.listaPretensionesPrincipales.filter(
        item => item.principal === false
      );
    }
  }

  agregarPretension() {
    if (this.modificoPretension && this.tramiteSic) {
      this.proteccionConsumidorService.eliminarPretensiones(this.tramiteSic.id!).subscribe((resp: any) => { });
    }
    const tipoPretension: TipoPretensionDto = {
      tipoPretension: this.getListaValor(this.formPretension.value['tipoPretension']),
      otraPretension: this.formPretension.get('otraPretension')?.value,
      principal: this.principal,
    }
    if (this.modificoPretension) {
      this.listaPretensionesPrincipales = [];
    }
    if (this.principal) {
      this.listaTipoPretension_pr_eg = this.listaTipoPretension_pr_eg
        .filter(item => item.Codigo !== this.formPretension.value['tipoPretension'])

      this.listaPretensionesPrincipales = this.listaPretensionesPrincipales
        .filter(item => item.principal !== true);
    } else {
      this.listaTipoPretension_pr_eg = this.listaTipoPretension_pr_eg
        .filter(item => item.Codigo !== this.formPretension.value['tipoPretension']);
    }

    this.listaPretensionesPrincipales.push(tipoPretension);
    this.mostar = false;
    this.principal = false
    this.modificoPretension = false;
    this.pretension.emit({
      listaPretenciones: this.listaPretensionesPrincipales
    })
    this.formPretension.reset();
  }

  modificarPretension() {
    const principal = this.listaPretensionesPrincipales
      .filter(item => item.principal === true);

    this.formPretension.get('tipoPretension')?.setValue(principal)
    this.mostar = true;
    this.principal = true
    this.modificoPretension = true;
    this.listaValor()
  }

  borrarPretension() {
    this.listaPretensionesPrincipales = []
    this.listaValor();
    // Se consume el servicio de eliminar pretensiones
    if (this.tramiteSic && this.tramiteSic?.id) {
      this.proteccionConsumidorService.eliminarPretensiones(this.tramiteSic.id).subscribe((resp: any) => { });
    }
  }

  cancelar() {
    this.mostar = false;
    this.principal = false
  }

  mostarPretencionSubsidiaria() {
    if (this.listaPretensionesPrincipales.length > 0 && this.listaTipoPretension_pr_eg.length > 0) {
      return true;
    }
    return false;
  }

  estaSeleccionado(codigo?: string): boolean {
    return this.listaPretensionesPrincipales.some(
      item => item.tipoPretension?.codigo === codigo
    );
  }

  getControlDetalle(codigo?: string): FormControl {
    return this.formPretension.get(`detalle_${codigo}`) as FormControl;
  }

  cambioPretension(event: any, tipo: ListaValorResponseDto) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const codigo = tipo.Codigo;
    const controlName = `detalle_${value}`;

    const exclusionPairs: Record<string, string[]> = {
      'TP_EBIS': ['TP_PVB'],
      'TP_PVB': ['TP_EBIS']
    };

    if (input.checked) {
      // Desmarcar opciones excluidas entre si
      if (codigo) {
        const excludedCodes = exclusionPairs[codigo] || [];

        excludedCodes.forEach(excludedCode => {
          // 4. Verificación adicional para excludedCode
          if (excludedCode && this.estaSeleccionado(excludedCode)) {
            this.listaPretensionesPrincipales = this.listaPretensionesPrincipales
              .filter(item => item.tipoPretension?.codigo !== excludedCode);

            const excludedControlName = `detalle_${excludedCode}`;
            if (this.formPretension.get(excludedControlName)) {
              this.formPretension.removeControl(excludedControlName);
            }
          }
        });
      }
      this.listaPretensionesPrincipales.push({
        tipoPretension: { codigo: tipo.Codigo, valor: tipo.Valor, id: tipo.Id },
        otraPretension: ''
      });

      // Actualizar el estado del checkbox obligatorio
      if (value === 'TP_IPSE' || value === 'TP_DVNPP' || value === 'TP_DAASC' || value === 'TP_DRHD') {
        this.formPretension.get('TP_requerida')?.setValue(true);
      }

      if (!this.formPretension.get(controlName)) {
        // Solo agregar validación requerida si no es el checkbox obligatorio
        const validators = (value === 'TP_AD' || value === 'TP_MCO' || value === 'TP_PI'
          || value === 'TP_DAASC' || value === 'TP_PSI' || value === 'TP_AA')
          ? [Validators.required]
          : [];

        const control = new FormControl('', validators);

        control.valueChanges.subscribe(val => {
          const index = this.listaPretensionesPrincipales.findIndex(
            item => item.tipoPretension?.codigo === value
          );
          if (index !== -1) {
            this.listaPretensionesPrincipales[index].otraPretension = val ?? undefined;
          }
        });

        this.formPretension.addControl(controlName, control);
      }
    } else {
      this.listaPretensionesPrincipales = this.listaPretensionesPrincipales
        .filter(item => item.tipoPretension?.codigo !== value);

      // Actualizar el estado del checkbox obligatorio
      if (value === 'TP_IPSE' || value === 'TP_DVNPP' || value === 'TP_DAASC' || value === 'TP_DRHD'
        ) {
        this.formPretension.get('TP_requerida')?.setValue(false);
      }

      if (this.formPretension.get(controlName)) {
        this.formPretension.removeControl(controlName);
      }
    }
  }

  anterior() {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }
  }

  pasarAFundamentosDerecho(e: Event, guardarSinEnviar: boolean) {

    if (!this.validarForm()) {
      this.formPretension.markAllAsTouched();
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(6));
    }
    let validado = false;
    const listaPretensiones: TipoPretensionDto[] = this.limpiarPretensiones(this.listaPretensionesPrincipales);

    switch (this.tramiteSic?.tipoProteccion?.tipoProteccion?.codigo) {
      case 'PR_EG': {
        validado = this.validacionPR_EG();
        break;
      }
      case 'PR_PC': {
        validado = this.validacionPR_PC();
        break;
      }
      case 'PR_PVDC': {
        validado = this.validacionPR_PVDC();
        break;
      }
      case 'PR_PSIB': {
        validado = this.validacionPR_PSIB();
        break;
      }
      case 'PR_PIE': {
        validado = this.validacionPR_PIE();
        break;
      }
    }
    if (validado) {

      const tramite: TramiteSicProteccionConsumidorDto = {
        juramento: this.formPretension.value['juramento'],
        tipoPretension: listaPretensiones
      };

      if (!guardarSinEnviar) {
        this.continuar.emit({
          tramite: tramite,
          formValid: validado,
          event: e,
        });
      } else {
        this.guardarSinEnviar.emit({
          tramite: tramite,
          formValid: validado,
          event: e,
        });
      }
    } else {
      const tramite: TramiteSicProteccionConsumidorDto = {
        juramento: this.formPretension.value['juramento'],
        tipoPretension: []
      };

      if (!guardarSinEnviar) {
        this.continuar.emit({
          tramite: tramite,
          formValid: validado,
          event: e,
        });
      } else {
        this.guardarSinEnviar.emit({
          tramite: tramite,
          formValid: validado,
          event: e,
        });
      }
    }
  }
  validarForm() {
    let validado = false;

    switch (this.tramiteSic?.tipoProteccion?.tipoProteccion?.codigo) {
      case 'PR_EG': {
        validado = this.validacionPR_EG();
        if (this.listaPretensionesPrincipales.length == 0) {
          validado = false;
        }
        break;
      }
      case 'PR_PC': {
        validado = this.validacionPR_PC();
        break;
      }
      case 'PR_PVDC': {
        validado = this.validacionPR_PVDC();
        break;
      }
      case 'PR_PSIB': {
        validado = this.validacionPR_PSIB();
        break;
      }
      case 'PR_PIE': {
        validado = this.validacionPR_PIE();
        break;
      }
    }
    return validado;
  }


  limpiarPretensiones(lista: TipoPretensionDto[]) {
    const mapa = new Map<number, TipoPretensionDto>();

    for (const item of lista) {
      const id = item.tipoPretension?.id;
      if (!id) continue;

      const existente = mapa.get(id);

      // Si no hay uno guardado todavía, lo guardamos
      if (!existente) {
        mapa.set(id, item);
        continue;
      }

      // Si el nuevo es principal y el guardado no lo es → reemplazar
      if (item.principal && !existente.principal) {
        mapa.set(id, item);
        continue;
      }

      // Si el guardado es principal y el nuevo no → ignorar nuevo
      if (existente.principal && !item.principal) {
        continue;
      }
    }

    return Array.from(mapa.values());
  }

  actualizarValidaciones(valor: string) {
    const otraPretension = this.formPretension.get('otraPretension');
    if (valor === 'TP_QRB' || valor === 'TP_COPL') {
      otraPretension?.setValidators([
        Validators.required,
        Validators.pattern(Constants.REGEX_WITHOUT_ESPACES),
        Validators.minLength(3),
        Validators.maxLength(1000),
      ]);
    } else {
      otraPretension?.clearValidators();
    }

    otraPretension?.updateValueAndValidity();
  }

  validacionPR_EG(): boolean {
    return this.listaPretensionesPrincipales?.length > 0;
  }

  validacionPR_PC(): boolean {
    this.formPretension.markAllAsTouched();

    // 1. Validar checkbox obligatorio TP_DVNPP
    const tieneTP_DVNPP = this.estaSeleccionado('TP_DVNPP');
    if (!tieneTP_DVNPP) return false;

    // 2. Validar checkbox obligatorio TP_DAASC
    const tieneTP_DAASC = this.estaSeleccionado('TP_DAASC');
    if (!tieneTP_DAASC) return false;

    // 2. Validar campos condicionales (si están seleccionados)
    const pretensionesConDetalle = this.listaPretensionesPrincipales
      .filter(p => ['TP_COPL', 'TP_DAASC'].includes(p.tipoPretension?.codigo || ''));

    for (const pretension of pretensionesConDetalle) {
      const codigo = pretension.tipoPretension?.codigo;
      const control = this.getControlDetalle(codigo);
      if (!control?.value?.trim()) return false;
    }
    return true;
  }

  validacionPR_PVDC(): boolean {
    this.formPretension.markAllAsTouched();

    // 1. Debe existir al menos una pretensión principal
    if (!this.listaPretensionesPrincipales || this.listaPretensionesPrincipales.length === 0) {
      return false;
    }

    // 2. Validar detalle SOLO si TP_COPL o TP_RB están seleccionadas
    const pretensionesConDetalle = this.listaPretensionesPrincipales
      .filter(p => ['TP_COPL', 'TP_RB'].includes(p.tipoPretension?.codigo || ''));

    for (const pretension of pretensionesConDetalle) {
      const codigo = pretension.tipoPretension?.codigo;
      const control = this.getControlDetalle(codigo);

      if (control && !control.value?.trim()) {
        return false;
      }
    }

    return true;
  }

  validacionPR_PSIB(): boolean {
    this.formPretension.markAllAsTouched();

    // 1. Validar checkbox obligatorio TP_DRHD
    const tieneTP_DVNPP = this.estaSeleccionado('TP_DRHD');
    if (!tieneTP_DVNPP) return false;

    // 2. Validar campos condicionales (si están seleccionados)
    const pretensionesConDetalle = this.listaPretensionesPrincipales
      .filter(p => ['TP_PSI', 'TP_AA'].includes(p.tipoPretension?.codigo || ''));

    for (const pretension of pretensionesConDetalle) {
      const codigo = pretension.tipoPretension?.codigo;
      const control = this.getControlDetalle(codigo);
      if (!control?.value?.trim()) return false;
    }

    // 3. Validar juramento
    // se quita validacion a juramento por bug #4362
    // const juramento = this.formPretension.get('juramento')?.value?.trim();
    // if (!juramento) return false;

    return true;
  }

  validacionPR_PIE(): boolean {
    this.formPretension.markAllAsTouched();
    // 1. Validar checkbox obligatorio TP_IPSE
    const tieneTP_IPSE = this.estaSeleccionado('TP_IPSE');
    if (!tieneTP_IPSE) return false;

    // 2. Validar campos condicionales (si están seleccionados)
    const pretensionesConDetalle = this.listaPretensionesPrincipales
      .filter(p => ['TP_AD', 'TP_MCO', 'TP_PI'].includes(p.tipoPretension?.codigo || ''));

    for (const pretension of pretensionesConDetalle) {
      const codigo = pretension.tipoPretension?.codigo;
      const control = this.getControlDetalle(codigo);
      if (!control?.value?.trim()) return false;
    }

    // 3. Validar juramento
    // se quita validacion a juramento por bug #4362
    // const juramento = this.formPretension.get('juramento')?.value?.trim();
    // if (!juramento) return false;

    return true;
  }

  getListaValor(codigo: string):
    ListaValorRequestDto {
    let item;
    switch (this.tramiteSic?.tipoProteccion?.tipoProteccion?.codigo) {
      case 'PR_EG': {
        item = this.listaTipoPretension_pr_eg.find(
          item => item.Codigo === codigo
        );
        break;
      }
      case 'PR_PC': {
        item = this.listaTipoPretension_pr_pc.find(
          item => item.Codigo === codigo
        );
        break;
      }
      case 'PR_PVDC': {
        item = this.listaTipoPretension_pr_pvdc.find(
          item => item.Codigo === codigo
        );
        break;
      }
      case 'PR_PSIB': {
        item = this.listaTipoPretension_pr_psib.find(
          item => item.Codigo === codigo
        );
        break;
      }
      case 'PR_PIE': {
        item = this.listaTipoPretension_pr_pie.find(
          item => item.Codigo === codigo
        );
        break;
      }
    }

    return {
      valor: item?.Valor,
      estado: item?.Estado,
      nombreLista: item?.Nombre_Lista,
      codigo: item?.Codigo,
      otroValor: item?.Otro_valor,
      idExterno: item?.Id_Externo,
      id: item?.Id,
    }
  }
}
